import { Component, OnInit, Input, Renderer2 } from '@angular/core';
import { GlobalService } from './../../../core/';
import { GlobalNamespace as _GlobalNS } from './../../../../environments/environment';
import { PropertyListItem } from "../../property";
import { FavoritePropertiesService } from '../../favorite-properties.service';

@Component({
  selector: 'tpl-property-search-shortsale',
  templateUrl: './search-shortsale.component.html',
  styleUrls: [
    '../templates.scss',
    './search-shortsale.component.scss'
  ],
  providers: [FavoritePropertiesService]
})
export class SearchShortsaleComponent implements OnInit {
  @Input() routes: any = {};
  @Input() iconLeft: string;
  @Input() showPropertyIdLink: boolean;
  @Input() showOpenNewWindowIcon: boolean;
  @Input('value') property: PropertyListItem;

  favoriteLoansUpdateData: any[];
  MyFavoritePropertiesCount = this._global.find((<any>_GlobalNS).paths.UserFavoritePropertiesCount);
  UserFavoritePropertiesMaxCount = this._global.find((<any>_GlobalNS).paths.UserFavoritePropertiesMaxCount);

  constructor(private render: Renderer2
    , private favoritePropertiesService: FavoritePropertiesService
    , private _global: GlobalService) {

    favoritePropertiesService.getFavoritesCount().subscribe(count => {
      this.MyFavoritePropertiesCount = count;
    });
  }

  ngOnInit() {
    this.showPropertyIdLink = (this.showPropertyIdLink === undefined)?false:true;
    this.showOpenNewWindowIcon = (this.showOpenNewWindowIcon === undefined)?false:true;

    if(this.property === undefined || typeof this.property !== 'object')
      console.log(new TypeError('@Input value is undefined'));
  }

  getFavIconClass(IsFavorite: number): any {
    if (IsFavorite === 1) {
      return 'fas fa-heart fav-heart-loan-selected';
    } else {
      return 'far fa-heart';
    }
  }

  updateFavorite(el: any, propertyId: number): void {
    let proceedToUpdate = false;
    const favIconId = el.getAttribute('data-fav-loan-icon-id');
    const isFavFlag = el.getAttribute('data-fav-loan-flag');
    if (isFavFlag === '1') {
      // -- Remove from favs
      this.render.removeAttribute(el, 'class');
      this.render.addClass(el, 'far');
      this.render.addClass(el, 'fa-heart');
      el.setAttribute('data-fav-loan-flag', '0');
      proceedToUpdate = true;
    } else {
      // -- Add to favs
      if (this.MyFavoritePropertiesCount < this.UserFavoritePropertiesMaxCount) {
        this.render.addClass(el, 'fas');
        this.render.addClass(el, 'fa-heart');
        this.render.addClass(el, 'fav-heart-loan-selected');
        el.setAttribute('data-fav-loan-flag', '1');
        proceedToUpdate = true;
      } else {
        this.favoritePropertiesService.setDisplayMaxFavCountErrorMessageDialog(true);
      }
    }

    if (proceedToUpdate) {
      this.favoritePropertiesService.updateFavorites(propertyId, el.getAttribute('data-fav-loan-flag'))
        .subscribe((res) => {
          this.favoriteLoansUpdateData = (<any>res).data;
          this.favoritePropertiesService.setFavoritesCount(this.favoriteLoansUpdateData[0].CurrentCount);
          this.favoritePropertiesService.setReloadFavoritePropertiesBar(true);
        }, (error) => {
         console.log('Couldnot update favorites');
      });
    }
  }

}
